import { useState } from 'react'
import type { Me } from '../api/types'
import { Mark } from '../components/primitives'
import { AuthPanel } from './AuthPanel'

/**
 * What a signed-out visitor sees at `/` on an install with no marketing page.
 *
 * The mark and the form, centred on the ground, and nothing to read past them:
 * whoever runs the install already decided to use it, so there is nothing to
 * argue. It opens on log in rather than sign up because the person standing
 * here has usually been here before; the panel switches mode in one tap.
 */
export function SignIn({ onSignedIn }: { onSignedIn: (me: Me) => void }) {
  const [mode, setMode] = useState<'signup' | 'login'>('login')

  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 28,
        padding: 'calc(40px + var(--safe-top)) max(20px, var(--safe-right)) calc(40px + var(--safe-bottom)) max(20px, var(--safe-left))',
        background: 'var(--ground)',
      }}
    >
      <h1
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          margin: 0,
          fontSize: 24,
          fontWeight: 700,
          letterSpacing: '-.035em',
        }}
      >
        <Mark size={32} />
        stagepost
      </h1>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <AuthPanel mode={mode} onModeChange={setMode} onSignedIn={onSignedIn} />
      </div>
    </main>
  )
}
